import { styled , Theme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Config from "@/config.json";

const drawerWidth = Config.drawerWidth;

const AppBarStyled = styled( AppBar , { shouldForwardProp: (prop) => prop !== 'open' })(({ theme , open }:{theme:Theme , open:boolean}) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  })
}));

export default AppBarStyled;